import { Component, OnInit, OnDestroy } from '@angular/core';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { StorageManagerService, AuthorizationService, CustomerService } from '../../shared/services/index';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { ICustomer, IIngestedDevicesChart } from '../../shared/models';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  public loggedIn = false;
  private subscription: Subscription;
  user: any;
  userName: string;
  customer: ICustomer;
  hasPermissions: any;
  chartData$: any;

  constructor (private activatedRoute: ActivatedRoute, private authenticationService: AuthenticationService, private authorizationService: AuthorizationService, private storageManagerService: StorageManagerService, private customerService: CustomerService) {

  }

  login() {
    this.authenticationService.login();
  }

  ngOnInit() {

    this.subscription = this.authorizationService.hasPermissionSubject.subscribe((res) => {
      this.hasPermissions = res;
    });

    this.hasPermissions = this.storageManagerService.read('hasPermission');

    this.storageManagerService.write('activeTab', 'device');

    this.subscription = this.authenticationService.getIsAuthorized().subscribe(
      (isAuthorized: boolean) => {
        this.loggedIn = isAuthorized;

        this.user = this.storageManagerService.read('userData');

        if (this.user) {
          this.userName = this.user.name;

          this.setUserName(this.userName);

          const storedCustomer = this.storageManagerService.read('currentCustomer');

          if (storedCustomer) {
            this.customer = typeof storedCustomer === 'object' ? storedCustomer : <ICustomer>JSON.parse(storedCustomer);
          }
        }
      });
  }

  setUserName(data) {

    this.userName = data;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
